enum BenchmarkingDashboardSnpPlanFilterEnum {
  All = "All",
  Yes = "Yes",
  No = "No",
}

export { BenchmarkingDashboardSnpPlanFilterEnum };